import {
  getAttackEventTags,
  AttackEventTagsArgs,
  AttackEventTagsResponse
} from './requests/attack-event-tags'
import { useContrastQuery } from '../../../hooks/use-contrast-query'
import { Query } from '../../../hooks/queries'
import { HTTPError } from '../../../api/fetch/decorate-fetch'

export interface UseAttackEventTagsResult {
  tags: string[]
  isLoading: boolean
  error: HTTPError | null
}

export function useAttackEventTags(
  organizationUuid: string
): UseAttackEventTagsResult {
  const { data, isLoading, error } = useContrastQuery<
    AttackEventTagsArgs,
    AttackEventTagsResponse
  >([Query.ATTACK_EVENT_TAGS, organizationUuid], getAttackEventTags, {
    organizationUuid
  })

  return {
    tags: !!data && Array.isArray(data.tags) ? data.tags : [],
    isLoading,
    error
  }
}
